import { apiRequest } from './apiClient';

export const fetchCareTip = (userId) =>
	apiRequest('/api/v1/users/me/care-tip/today', { userId });

// Every rating this user has logged. The endpoint takes no filters, so the page
// narrows by date and goal itself — the prototype's volume is a handful of rows
// per person. This is what tells the Tracking page what was already submitted
// before the current visit; a set built up in component state only ever knew
// about the ratings made since the page was opened.
export const fetchRatingLogs = (userId) =>
	apiRequest('/api/v1/users/me/rating-logs', { userId });

// `date` and `startTime` say when the rating is *for*, not when it was typed.
// Left out, the server stamps the moment the request arrives, which is right
// for tracking as you go and wrong for catching up on a day you missed.
// `startTime` is 'HH:MM' from the time input; the API wants a full time.
export const saveRatingLog = (
	{ goalSettingId, rating, date, startTime },
	userId
) =>
	apiRequest('/api/v1/users/me/rating-logs', {
		method: 'POST',
		userId,
		body: {
			ratings: [
				{
					goal_setting_id: goalSettingId,
					rating,
					source: 'manual',
					...(date ? { date } : {}),
					...(startTime ? { start_time: `${startTime}:00` } : {}),
				},
			],
		},
	});

export const fetchFavoriteCareTips = ({ cursor, pageSize = 20 }, userId) => {
	const params = new URLSearchParams({ page_size: pageSize });
	if (cursor != null) {
		params.set('cursor', cursor);
	}
	return apiRequest(
		`/api/v1/users/me/care-tip-logs/favorites?${params.toString()}`,
		{ userId }
	);
};

export const favoriteCareTip = (careTipLogId, userId) =>
	apiRequest(`/api/v1/users/me/care-tip-logs/${careTipLogId}/favorite`, {
		method: 'POST',
		userId,
	});

export const unfavoriteCareTip = (careTipLogId, userId) =>
	apiRequest(`/api/v1/users/me/care-tip-logs/${careTipLogId}/favorite`, {
		method: 'DELETE',
		userId,
	});

// `ratingLogId` links the entry to the rating it was written with. The Journey
// day view and the report join on that link, so an entry saved without it is
// stored but never shown beside its submission.
// The entry carries only a date — the time it belongs to comes from the rating
// it is linked to.
export const saveDiaryEntry = (
	{ goalSettingId, content, ratingLogId, date },
	userId
) =>
	apiRequest('/api/v1/users/me/diary-entries', {
		method: 'POST',
		userId,
		body: {
			goal_setting_id: goalSettingId,
			content,
			...(ratingLogId != null ? { rating_log_id: ratingLogId } : {}),
			...(date ? { date } : {}),
		},
	});
